module.exports = __webpack_public_path__ + "static/img/r-5-4.fc50f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/r-5-4.png
// module id = zjwc
// module chunks = 0